var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('parent',[(_vm.loading)?_c('loading-page'):_c('lifecycle-form',{attrs:{"details":"","edited-settings":_vm.settings},on:{"close":_vm.cancel,"save":_vm.save}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }